module.exports = __webpack_public_path__ + "img/ig.1cfaab44.png";